import { render, staticRenderFns } from "./geocercasLeecheros.vue?vue&type=template&id=38960629&scoped=true"
import script from "./geocercasLeecheros.vue?vue&type=script&lang=js"
export * from "./geocercasLeecheros.vue?vue&type=script&lang=js"
import style0 from "./geocercasLeecheros.vue?vue&type=style&index=0&id=38960629&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38960629",
  null
  
)

export default component.exports